<template>
    <div class="engagement-info__table-view aligncenter engagement-table-scroll">
        <div role="table grid" class="r-table r-table--engagement r-table--no-stack-mobile">
            <div role="row" class="r-table__row r-table__row--header">
                <div role="columnheader" aria-colindex="1" class="r-table__cell no-border fixed r-table__cell--logo"><span class="sr-only">Logo</span></div>
                <div role="columnheader" aria-colindex="2" class="r-table__cell r-table__cell--is-sortable r-table__cell--name" :class="'name' === sortBy ? ['sort-active', 'sort-' + sortOrder] : ''" @click="handleSortClick('name')">{{orgHeading}}</div>
                <div role="columnheader" aria-colindex="3" class="r-table__cell r-table__cell--is-sortable fixed r-table__cell--member" :class="'is_member' === sortBy ? ['sort-active', 'sort-' + sortOrder] : ''" @click="handleSortClick('is_member')">Member</div>
                <div role="columnheader" aria-colindex="4" class="r-table__cell r-table__cell--is-sortable fixed r-table__cell--resil" :class="'engagement.badges.resiliency.has_badge' === sortBy ? ['sort-active', 'sort-' + sortOrder] : ''" @click="handleSortClick('engagement.badges.resiliency.has_badge')"><span aria-hidden="true">Resiliency</span><span class="sr-only">Resiliency Badge</span></div>
                <div role="columnheader" aria-colindex="5" class="r-table__cell r-table__cell--is-sortable fixed r-table__cell--transp" :class="'engagement.badges.transparency.has_badge' === sortBy ? ['sort-active', 'sort-' + sortOrder] : ''" @click="handleSortClick('engagement.badges.transparency.has_badge')"><span aria-hidden="true">Transparency</span><span class="sr-only">Transparency Badge</span></div>
                <!-- <div role="columnheader" aria-colindex="6" class="r-table__cell r-table__cell--is-sortable fixed r-table__cell--scorecard" :class="'engagement.scorecard' === sortBy ? ['sort-active', 'sort-' + sortOrder] : ''" @click="handleSortClick('engagement.scorecard')">Scorecard</div>
                <div role="columnheader" aria-colindex="7" class="r-table__cell r-table__cell--is-sortable fixed r-table__cell--bcm" :class="'engagement.bcm_assessment' === sortBy ? ['sort-active', 'sort-' + sortOrder] : ''" @click="handleSortClick('engagement.bcm_assessment')">Assessment</div>
                <div role="columnheader" aria-colindex="8" class="r-table__cell r-table__cell--is-sortable fixed r-table__cell--mapping" :class="'engagement.mapping' === sortBy ? ['sort-active', 'sort-' + sortOrder] : ''" @click="handleSortClick('engagement.mapping')">Mapping</div> -->
                <div role="columnheader" aria-colindex="9" class="r-table__cell fixed r-table__cell--contact">Contact</div>
            </div>
            <div v-for="(org, index) in orgs" :key="org.id" role="row" class="r-table__row" @click.prevent="handleItemClick(index)">
                <div role="gridcell" aria-colindex="1" class="r-table__cell fixed no-border r-table__cell--logo">
                    <img v-if="org.logo.logo_image" :src="org.logo.logo_image" :alt="'Logo for ' + org.name">
                </div>
                <div role="gridcell" aria-colindex="2" class="r-table__cell r-table__cell--name">
                    {{org.name}}
                </div>
                <div role="gridcell" aria-colindex="3" class="r-table__cell fixed r-table__cell--member">
                    <div v-if="org.is_member" v-tooltip="'HIRC Member'">
                        <svg class="has-blue-color" width="21" height="17" viewBox="0 0 21 17"><use xlink:href="#icon--hirc-h"></use></svg>
                    </div>
                </div>
                <div role="gridcell" aria-colindex="4" class="r-table__cell fixed r-table__cell--resil">
                    <div v-if="isProviderList && supportsResiliencyBadge(isProviderList && org)" v-tooltip="'Resiliency Badge: ' + capitalizeEngageLevel(org.engagement.badges.resiliency.support_level)">
                        <engagement-icon :engagement="org.engagement.badges.resiliency.support_level"></engagement-icon>
                    </div>
                    <div v-else>
                        <img v-if="org.engagement?.badges?.resiliency?.has_badge" v-tooltip="getLatestBadgeName(org.engagement.badges.resiliency.year_badges)" src="/wp-content/themes/hirc-custom/public/img/mini-badge-resiliancy.svg" alt="Resiliency Badge" style="width: 33px; height: auto;">
                    </div>
                </div>
                <div role="gridcell" aria-colindex="5" class="r-table__cell fixed r-table__cell--transp">
                    <div v-if="isProviderList && supportsTransparencyBadge(isProviderList && org)" v-tooltip="'Resiliency Badge: ' + capitalizeEngageLevel(org.engagement.badges.transparency.support_level)">
                        <engagement-icon :engagement="org.engagement.badges.transparency.support_level"></engagement-icon>
                    </div>
                    <div v-else>
                        <img v-if="org.engagement?.badges?.transparency?.has_badge" v-tooltip="'Transparency Badge: Partner ' + org.engagement.badges.transparency.version" src="/wp-content/themes/hirc-custom/public/img/mini-badge-transparency.svg" :alt="'Transparency Badge: Partner ' + org.engagement.badges.transparency.version" style="width: 33px; height: auto;">
                    </div>
                </div>
                <!-- <div role="gridcell" aria-colindex="6" class="r-table__cell fixed r-table__cell--scorecard">
                    <div v-tooltip="'Resiliency Scorecard: ' + capitalizeEngageLevel(org.engagement.scorecard)">
                        <engagement-icon :engagement="org.engagement.scorecard"></engagement-icon>
                    </div>
                </div>
                <div role="gridcell" aria-colindex="7" class="r-table__cell fixed r-table__cell--bcm">
                    <div v-tooltip="'Resiliency Lite Assessment: ' + capitalizeEngageLevel(org.engagement.bcm_assessment)">
                        <engagement-icon :engagement="org.engagement.bcm_assessment"></engagement-icon>
                    </div>
                </div>
                <div role="gridcell" aria-colindex="8" class="r-table__cell fixed r-table__cell--mapping">
                    <div v-tooltip="'Mapping & Monitoring: ' + capitalizeEngageLevel(org.engagement.mapping)">
                        <engagement-icon :engagement="org.engagement.mapping"></engagement-icon>
                    </div>
                </div> -->
                <div role="gridcell" aria-colindex="9" class="r-table__cell fixed r-table__cell--contact">
                    {{org.contact}}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { nextTick, defineEmits } from 'vue'
    import EngagementIcon from './EngagementIcon.vue'

    const props = defineProps({
        orgs: Array,
        orgHeading: { type: String, default: 'Name'},
        sortBy: String,
        sortOrder: String,
        isProviderList: { type: Boolean, default: false },
    })

    const emits = defineEmits(['itemClicked', 'columnHeaderClicked'])

    const capitalizeEngageLevel = (engagement) => {
        let str = 'undefined'
        if(engagement) {
            str = engagement.charAt(0).toUpperCase() + engagement.slice(1)
        }
        return str;
    }
    const handleItemClick = (index) => {
        emits('itemClicked', index)
    }
    const handleSortClick = (propPath) => {
        emits('columnHeaderClicked', propPath)
    }

    const getLatestBadgeName = (yearBadges) => {
        // console.log({'yearBadges' : yearBadges});
        if (yearBadges) {
            const latestBadge = yearBadges.reduce((latest, current) => {
                return (latest.year > current.year) ? latest : current;
            }, { year: "0" }); // Default to year "0" if no badges found
            // console.log({'latestBadge' : latestBadge});
            if (latestBadge && latestBadge.badge_data && latestBadge.badge_data.length > 0) {
                // console.log({'latestBadge.badge_data[0]' : latestBadge.badge_data[0].name});
                return latestBadge.badge_data[0].name; // Assuming you want the first badge's name
            }
        }
        return "No badge found";
    }

    const supportsResiliencyBadge = (org) => {
        return org.engagement?.badges.resiliency.support_level === 'adopted' || org.engagement?.badges.resiliency.support_level === 'engaged'
    }
    const supportsTransparencyBadge = (org) => {
        return org.engagement?.badges.transparency.support_level === 'adopted' || org.engagement?.badges.transparency.support_level === 'engaged'
    }

</script>

<style scoped>
.r-table {
    min-width: 900px;
}
.r-table--engagement .r-table__row {
    cursor: pointer;
}
.r-table__cell--logo, .r-table__cell--member, .r-table__cell--transp, .r-table__cell--resil, .r-table__cell--scorecard, .r-table__cell--bcm, .r-table__cell--mapping {
    flex: 0 0 90px;
    justify-content: center;
}
.r-table__cell--resil, .r-table__cell--transp {
    flex-basis: 100px;
}
.r-table__cell--transp {
    flex-basis: 124px;
}
.r-table__cell--logo {
    padding-right: 20px;
}
.r-table__cell--name {
    font-family: 'Open Sans Bold', sans-serif;
    font-weight: 700;
}
.r-table--engagement  .r-table__cell--logo img {
    max-height: 40px;
}
@media screen and (min-width: 1024px) {
    .r-table__cell--logo {
        flex-basis: 120px
    }
}
@media screen and (max-width: 1023px) {
    .engagement-table-scroll {
        overflow-y: auto;
    }
}
</style>